const addNotification = 'INTERCEPT_ADD_NOTIFICATION';
const removeNotification = 'INTERCEPT_REMOVE_NOTIFICATION';
const updateNotification = 'INTERCEPT_UPDATE_NOTIFICATION';
const toggleNotificationsElement = 'INTERCEPT_TOGGLE_NOTIFICATIONS';
const hideNotifications = 'INTERCEPT_HIDE_NOTIFICATIONS';

const initialState = { notifications: [], isAdding: false, showNotifications: false, hasPendingNotifications: false, unreadNotificationCount: 0 };


export const actionCreators = {
	addNotification: (notification) => async (dispatch) => {
		try {
			dispatch({ type: addNotification, notification: notification });
		}
		catch (e) { }
	},

	updateNotification: (notification) => async (dispatch) => {
		try {
			dispatch({ type: updateNotification, notification: notification });
		}
		catch (e) { }
	},

	removeNotification: (notification) => async (dispatch) => {
		try {
			dispatch({ type: removeNotification, notification: notification });
		}
		catch (e) { }
	},
	toggleNotificationsElement: () => async (dispatch) => {
		try {
			dispatch({ type: toggleNotificationsElement });
		}
		catch (e) { }
	},
	hideNotificationsElement: () => async (dispatch) => {
		try {
			dispatch({ type: hideNotifications });
		}
		catch (e) { }
	}
};


const hasPendingNotifications = (notifications) => {
	return notifications.some(isPendingNotification);
}

const isPendingNotification = (notification) => {
	return notification.pending;
}

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === addNotification) {

		var unreadNotificationCount = state.unreadNotificationCount + 1;
		var existingItem = state.notifications.find((element) => {
			return element.id === action.notification.id;
		});
		var newNotificationsFromAdd = [action.notification].concat(state.notifications);
		if (existingItem === undefined) {
			return {
				...state,
				notifications: newNotificationsFromAdd,
				hasPendingNotifications: hasPendingNotifications(newNotificationsFromAdd),
				unreadNotificationCount: unreadNotificationCount
			};
		}
	}

	if (action.type === updateNotification) {

		var newNotificationsFromUpdate = state.notifications.map(
			(content, i) => i.id === action.notification.id ?
				{
					...content,
					name: action.notification.name,
					pending: action.notification.pending,
					succes: action.notification.succes,
				}
				: content)

		return {
			...state,
			notifications: newNotificationsFromUpdate,
			hasPendingNotifications: hasPendingNotifications(newNotificationsFromUpdate),
			showNotifications: !hasPendingNotifications(newNotificationsFromUpdate)
		};
	}

	if (action.type === removeNotification) {
		return {
			...state,
			//notifications: 
		};
	}

	if (action.type === toggleNotificationsElement) {
		return {
			...state,
			showNotifications: !state.showNotifications,
			unreadNotificationCount: 0

		};
	}

	if (action.type === hideNotifications) {
		return {
			...state,
			showNotifications: false
		};
	}

	return state;
};


// WEBPACK FOOTER //
// ./src/store/Notifications.js